import React, { useState } from "react";
import Box from "@mui/material/Box";
import { useEffect } from "react";
import { Button, Card, Divider, Paper, Typography } from "@mui/material";
import TimeStamp from "./TimeStamp";
import moment from "moment";
import { Input } from "@mui/joy";

export default function InoutLive({ updateData }) {
  const [firstData, setFirstData] = useState([]);
  const [inData, setIndata] = useState(0);
  const [workData, setWorkData] = useState(0);
  const [outData, setOutData] = useState(0);
  const [releaseData, setReleaseData] = useState(0);
  const [offData, setOffData] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const apiUrl = process.env.REACT_APP_APICARGO;

  useEffect(() => {
    liveFirstData();

    const intervalId = setInterval(() => {
      liveFirstData();
    }, 10 * 1000); //  5 * 60 *
    return () => {
      // 컴포넌트가 언마운트되면 clearInterval을 통해 인터벌을 정리
      clearInterval(intervalId);
    };
  }, []); // 빈 배열을 전달하여 컴포넌트가 처음 마운트될 때만 실행

  const liveFirstData = async () => {
    try {
      const response = await fetch(`${apiUrl}/sams/stlive`);
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }
      const res = await response.json();

      if (res.length === 0) {
        // 처리할 내용이 있다면 여기에 추가
      } else {
        const searchData = res.map((row, index) => ({
          id: index,
          sid: row.cargoSid,
          inSid: row.inSid,
          mawb: row.mawb,
          inWeight: parseFloat(row.inWeight),
          inTime:
            row.inTime === null || row.inTime === ""
              ? ""
              : moment(row.inTime).format("MM-DD HH:mm:ss"),
          terminalCode: row.terminalCode,
          searchStatus: row.status,
          eWorkList: row.eworkList.map((rows, indexs) => ({
            uldId: indexs,
            uldSid: rows.uldSid,
            cargoSid: rows.cargoSid,
            inoutSid: rows.inoutSid,
            uldNo: rows.uldNo,
            workWt: parseFloat(rows.workWt),
            workDt:
              rows.workDt === null || rows.workDt === ""
                ? ""
                : moment(rows.workDt).format("MM-DD HH:mm:ss"),
            bupFlag: rows.bupFlag,
            outWt: parseFloat(rows.outWt),
            outDt:
              rows.outDt === null || rows.outDt === ""
                ? ""
                : moment(rows.outDt).format("MM-DD HH:mm:ss"),
            offDt:
              rows.offDt === null || rows.offDt === ""
                ? ""
                : moment(rows.offDt).format("MM-DD HH:mm:ss"),
            outKind: rows.outKind,
            outKindName: rows.outKindName,
          })),
        }));

        //Data 통으로 담음
        setFirstData(searchData);
      }
    } catch (error) {
      console.error("Error in liveFirstData:", error);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIndata(
        firstData
          .reduce((sum, item) => sum + (item.inWeight / 1000 || 0), 0)
          .toFixed(2)
      );
      setWorkData(
        firstData
          .reduce(
            (acc, row) =>
              acc +
              row.eWorkList.reduce(
                (accWt, rows) => accWt + (rows.workWt / 1000 || 0),
                0
              ),
            0
          )
          .toFixed(2)
      );
      setOutData(
        firstData
          .reduce(
            (acc, row) =>
              acc +
              row.eWorkList.reduce(
                (accWt, rows) => accWt + (rows.outWt / 1000 || 0),
                0
              ),
            0
          )
          .toFixed(2)
      );
      setReleaseData(
        firstData
          .reduce(
            (acc, row) =>
              acc +
              row.eWorkList
                .filter((rows) => rows.outKind === "60")
                .reduce((accWt, rows) => accWt + (rows.outWt / 1000 || 0), 0),
            0
          )
          .toFixed(2)
      );

      var offDtCount = 0;

      firstData.forEach((row) => {
        row.eWorkList.forEach((rows) => {
          if (rows.offDt !== null && rows.offDt !== "") {
            offDtCount++;
          }
        });
      });

      setOffData(offDtCount);
    }, 1000);
    return () => {
      // 컴포넌트가 언마운트되면 clearInterval을 통해 인터벌을 정리
      clearInterval(intervalId);
    };
  }, [firstData]);

  useEffect(() => {
    if (searchTerm == "") {
      updateData(firstData);
    } else {
      var pattern = /[a-zA-Z]/;
      let fileterData = [];
      if (pattern.test(searchTerm)) {
        fileterData = firstData
          .map((row, index) => ({
            id: index,
            sid: row.cargoSid,
            inSid: row.inSid,
            mawb: row.mawb,
            inWeight: parseFloat(row.inWeight),
            inTime:
              row.inTime === null || row.inTime === ""
                ? ""
                : moment(row.inTime).format("MM-DD HH:mm:ss"),
            terminalCode: row.terminalCode,
            searchStatus: row.status,
            eWorkList: row.eWorkList.filter((item) => {
              return (
                item.uldNo?.includes(searchTerm) ||
                item.outKindName?.includes(searchTerm)
              );
            }),
          }))
          .filter((item) => item.eWorkList.length > 0);
      } else {
        fileterData = firstData.filter((item) => {
          return (
            item.mawb.includes(searchTerm) ||
            item.terminalCode.includes(searchTerm)
          );
        });
      }
      updateData(fileterData);
    }
  }, [searchTerm, firstData]);

  return (
    <Box
      sx={{
        backgroundColor: "#f8f9fa",
        p: 0.5,
        display: "flex",
        fontWeight: "bold",
      }}
    >
      <Paper
        sx={{
          m: 0.5,
          p: 1.5,

          width: 260,
          height: 45,
          backgroundColor: "#f1f3f5",
        }}
        elevation={12}
      >
        <TimeStamp />
      </Paper>

      <Input
        size="md"
        placeholder="Search...."
        variant="soft"
        value={searchTerm}
        sx={{ mr: 35 }}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      <Paper
        sx={{
          m: 0.5,
          p: 1.5,
          width: 180,
          height: 45,
          backgroundColor: "#f1f3f5",
          display: "flex",
        }}
        elevation={12}
      >
        <Typography
          component="p"
          variant="h7"
          sx={{ textAlign: "left", marginRight: 2, color: "#868e96" }}
        >
          입고
        </Typography>
        <Typography
          component="p"
          variant="h7"
          sx={{ textAlign: "right", marginLeft: 2, color: "#212529" }}
        >
          {inData} TON
        </Typography>
      </Paper>
      <Paper
        sx={{
          m: 0.5,
          p: 1.5,
          width: 180,
          height: 45,
          backgroundColor: "#f1f3f5",
          display: "flex",
        }}
        elevation={12}
      >
        <Typography
          component="p"
          variant="h7"
          sx={{ textAlign: "left", marginRight: 2, color: "#868e96" }}
        >
          작업
        </Typography>
        <Typography
          component="p"
          variant="h7"
          sx={{ textAlign: "right", marginLeft: 2, color: "#212529" }}
        >
          {workData} TON
        </Typography>
      </Paper>
      <Paper
        sx={{
          m: 0.5,
          p: 1.5,
          width: 180,
          height: 45,
          backgroundColor: "#f1f3f5",
          display: "flex",
        }}
        elevation={12}
      >
        <Typography
          component="p"
          variant="h7"
          sx={{ textAlign: "left", marginRight: 2, color: "#868e96" }}
        >
          출고
        </Typography>
        <Typography
          component="p"
          variant="h7"
          sx={{ textAlign: "right", marginLeft: 2, color: "#212529" }}
        >
          {outData} TON
        </Typography>
      </Paper>
      <Paper
        sx={{
          m: 0.5,
          p: 1.5,
          width: 200,
          height: 45,
          backgroundColor: "#f1f3f5",
          display: "flex",
        }}
        elevation={12}
      >
        <Typography
          component="p"
          variant="h7"
          sx={{ textAlign: "left", marginRight: 2, color: "#868e96" }}
        >
          취하출고
        </Typography>
        <Typography
          component="p"
          variant="h7"
          sx={{ textAlign: "right", marginLeft: 2, color: "#212529" }}
        >
          {releaseData} TON
        </Typography>
      </Paper>
      <Paper
        sx={{
          m: 0.5,
          p: 1.5,
          width: 200,
          height: 45,
          backgroundColor: "#f1f3f5",
          display: "flex",
        }}
        elevation={12}
      >
        <Typography
          component="p"
          variant="h7"
          sx={{ textAlign: "left", marginRight: 2, color: "#868e96" }}
        >
          오프로드 건
        </Typography>
        <Typography
          component="p"
          variant="h7"
          sx={{ textAlign: "right", marginLeft: 2, color: "#212529" }}
        >
          {offData} 건
        </Typography>
      </Paper>
    </Box>
  );
}
